import React, { Component } from 'react';
import { connect } from 'react-redux';
import { dAPI } from 'appSrc/api';
import { DLTextField, PrimaryButton } from 'appSrc/components/UI';
import LoadingReplace from 'appSrc/components/Shards/Loading/LoadingReplace';
import AllHomepageItemsTable from './Table';
import NewItemModal from '../../../Modals/HomepageHeroItem/NewItemModal';
import { Link } from 'react-router-dom';
import style from './styles/style.module.css';

class AllHomepageHeroItemsView extends Component {
    constructor( props ) {
        super( props );
        this.state = {
            fetching: true,
            newModal: false,
            items: [],
            searchValue: '',
        };

        this.itemQueryObject = {
            sort: 'id',
            search: undefined,
            page: 1,
            limit: 30,
            context: this.props.match.params.context,
        };
    }
    
    componentDidMount() {
        this.loadItems();
    }

    updateSearch = ( e, { value } ) => {
        this.setState( { searchValue: value } );
    }
    
    onSearchKeyDown = ( e ) => {
        if( e.keyCode == 13 ) {
            e.preventDefault();
            this.itemQueryObject.search = this.state.searchValue || undefined;
            this.itemQueryObject.page = 1;
            this.setState( {
                fetching: true,
                items: [],
            } );
            this.loadItems();
        }
    }

    onColumnSort = ( value ) => {
        if( this.itemQueryObject.sort == value ) {
            value = `-${ value }`;
        }
        this.itemQueryObject.sort = value;
        this.itemQueryObject.page = 1;
        this.setState( {
            fetching: true,
            items: [],
        } );
        this.loadItems();
    }

    loadItems = () => {
        return this.props.getHomepageHeroItems( this.itemQueryObject )
        .then( ( items ) => {
            this.itemQueryObject.page++;
            this.setState( ( prevState ) => {
                prevState.fetching = false;
                prevState.items = prevState.items.concat( items );
                return prevState;
            } );
            return items;
        } );
    }

    itemUpdated = ( index, item ) => {
        this.setState( ( altState ) => {
            if( item !== null ) {
                altState.items[ index ] = item;
            } else {
                altState.items.splice( index, 1 );
            }
            altState.items = altState.items.slice( 0 );
            return altState;
        } );
    }

    openNewModal = () => {
        this.setState( { newModal: true } );
    }

    onNewModalClose = () => {
        this.setState( { newModal: false } );
    }

    onNewModalSubmit = ( newItem ) => {
        this.setState( ( altState ) => {
            altState.items.unshift( newItem );
            altState.items = altState.items.slice( 0 );
            altState.newModal = false;
            return altState;
        } );
    }

    capitalize(str){
        return str.charAt(0).toUpperCase() + str.slice(1);
    }
        

    render() {
        const { fetching, items, searchValue } = this.state;
        return (
            <section className={ style.page }>
                <div className={ style.head }>
                    <h2>{ this.capitalize(this.itemQueryObject.context.replace('_',' ')) }</h2>
                    <div className={ style.controls }>
                        <DLTextField className={ style.searchBar }
                        placeholder='Search'
                        value={ searchValue }
                        onChange={ this.updateSearch }
                        onKeyDown={ this.onSearchKeyDown }
                        noError />
                        <PrimaryButton
                        label='+ Create Item'
                        style={ { width: '150px' } }
                        onClick={ this.openNewModal } />
                    </div>
                    <div className={ style.tabs }>
                        { this.itemQueryObject.context != 'homepage_hero' && 
                            <Link to='/admin/ctas/contexts' className={ style.tabOption }>Action Item Contexts</Link>
                        }   
                        <Link to={'/admin/ctas/items/' + this.itemQueryObject.context } className={ style.tabOption }
                        data-active={ true }>Items</Link>
                        { this.itemQueryObject.context == 'homepage_hero' && 
                            <Link to='/admin/homepage/settings' className={ style.tabOption }>Settings</Link>
                        } 
                         

                    </div>
                </div>
                <div className={ style.body }>
                    <section className={ style.allItem }>
                        <div className={ style.filters }>
                        </div>
                        { fetching ?
                            <LoadingReplace />
                            :
                            <AllHomepageItemsTable
                            items={ items }
                            loadMore={ this.loadItems }
                            currentSort={ this.itemQueryObject.sort }
                            onColumnSort={ this.onColumnSort }
                            onItemUpdated={ this.itemUpdated }
                            elementHeight={ 70 } />
                        }
                    </section>
                </div>
                { this.state.newModal &&
                    <NewItemModal closeModal={ this.onNewModalClose }
                    onSubmit={ this.onNewModalSubmit } context={ this.itemQueryObject.context } />
                }
            </section>
        );
    }
}

const mapDispatchToProps = () => {
    return {
        getHomepageHeroItems: ( itemQueryObject ) => {
            return dAPI.get( '/admin/homepage/hero', itemQueryObject );
        },
    };
};

export default connect( null, mapDispatchToProps )( AllHomepageHeroItemsView );
